import { ReactNode } from 'react';
import { Body1, Caption1, makeStyles, tokens } from '@fluentui/react-components';

export type TDefinitionItem = {
  label: string;
  value: ReactNode;
};

const useStyles = makeStyles({
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  row: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXS,
  },
  label: {
    color: tokens.colorNeutralForeground3,
  },
});

// Read-only label/value pairs. The initiator's submitted request and the triage
// side summary both render through this so read-only content stays consistent.
export const DefinitionList = ({ items }: { items: TDefinitionItem[] }) => {
  const classes = useStyles();
  return (
    <div className={classes.list}>
      {items.map((item) => (
        <div key={item.label} className={classes.row}>
          <Caption1 className={classes.label}>{item.label}</Caption1>
          <Body1>{item.value}</Body1>
        </div>
      ))}
    </div>
  );
};
